export default {"src":"/_next/static/media/bulgaria.f5651ee7.svg","height":512,"width":512};